module.exports = __webpack_public_path__ + "img/5@2x.cf7e9465.png";